import Vue from "vue";

export default Vue.directive('blur', {
    inserted: function (el) {
        // @ts-ignore
        el.onfocus = (ev) => ev.target.blur();
    },
});
